export const SOCIAL_LINKS = [
  {
    id: "facebook",
    href: "https://www.facebook.com/bestgroom.wroclaw",
    label: "Facebook",
  },
  {
    id: "instagram",
    href: "https://www.instagram.com/best.groom.studio/",
    label: "Instagram",
  },
] as const;

export type SocialLinkId = (typeof SOCIAL_LINKS)[number]["id"];
